import {
  type UserConstructorData,
  User,
} from '@webapp/core/entities/internal/User'
import {
  AuditLogChangedField,
  type AuditLogChangedFieldConstructorData,
} from '../AuditLogChangedField'
import { type AuditLogStatusEnum } from '../enums/AuditLogStatusEnum'

export interface AuditLogRecordConstructorData {
  changedOn: ISODateString
  changedBy: UserConstructorData
  title: string
  changedFields: AuditLogChangedFieldConstructorData[]
  status: AuditLogStatusEnum
  delegatee?: UserConstructorData
}

export class AuditLogRecord {
  changedOn: Date
  changedBy: User
  title: string
  changedFields: AuditLogChangedFieldConstructorData[]
  status: AuditLogStatusEnum
  delegatee?: User

  constructor(data: AuditLogRecordConstructorData) {
    this.changedOn = new Date(data.changedOn)
    this.changedBy = new User(data.changedBy)
    this.title = data.title
    this.changedFields = data.changedFields.map(
      (change) => new AuditLogChangedField(change)
    )
    this.status = data.status
    this.delegatee = data?.delegatee ? new User(data.delegatee) : undefined
  }
}
